import { Injectable, inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient,HttpContext } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { Country, Department, IParametric, Locality, Municipality } from 'src/app/shared/interfaces/parametric.interface';
import { SupportParametric } from 'src/app/shared/interfaces/supporarea';

@Injectable({
  providedIn: 'root'
})
export class AdministratorService {

  private readonly urlAdministrator = environment.titanAdminUrl;
  private http = inject(HttpClient);
    // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}

  getParametric(type: string): Observable<IParametric[]>{
    const url = `${this.urlAdministrator}/api/Parametric/${type}`
    return this.http.get<IParametric[]>(url).pipe(
      map((parametrics: IParametric[]) => parametrics.filter(parametric => parametric.isActive))
      );
  }

  getSuperGroup(language:string): Observable<IParametric[]>{
    const url = `${this.urlAdministrator}/api/Thematic/All/${language}`
    return this.http.get<IParametric[]>(url).pipe(
      map((parametrics: IParametric[]) =>{
        parametrics.map(x=>x.thematics.map(x=>x.selected=false));
        return parametrics.filter(parametric => parametric.isActive)
      })
      );
  }
  getSupportArea(language: string): Observable<SupportParametric[]>{
    const url = `${this.urlAdministrator}/api/SupportArea/${language}`
    return this.http.get<SupportParametric[]>(url);
  }

  getCountry(): Observable<Country[]>{
    const url = `${this.urlAdministrator}/api/Country`
    return this.http.get<Country[]>(url);
  }

  getDepartment(): Observable<Department[]>{
    const url = `${this.urlAdministrator}/api/Department/CO`
    return this.http.get<Department[]>(url);
  }

  getMunicipality(deparmentCode: string): Observable<Municipality[]>{
    const url = `${this.urlAdministrator}/api/Municipality/CO/Department/${deparmentCode}`
    return this.http.get<Municipality[]>(url);
  }

  changeLocalities(deparmentCode: string,cityCode: string): Observable<Locality[]>{
    const url = `${this.urlAdministrator}/api/Locality/CO/Municipality/${deparmentCode}/${cityCode}`
    return this.http.get<Locality[]>(url);
  }

}
